export const isNullOrWhitespace = string => {
  return string === null || string === undefined || string.match(/^ *$/) !== null;
};
